import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'logo-edicion',
    templateUrl: './logo-edicion.component.html',
    styleUrl: './logo-edicion.component.scss'
})
export class LogoEdicionComponent implements OnChanges {

    @Input() numeroEdicion: string = "";
    @Input() anoEdicion: number = 0;
    private _numeroEdicionTexto: string = "";

    ngOnChanges(changes: SimpleChanges): void {
        this.calcularEdicionTexto(this.anoEdicion);
    }

    private calcularEdicionTexto(anoActual: number) {
        // Define los valores enteros y sus símbolos romanos correspondientes
        if (anoActual === 0) {
            return;
        }

        let num: number = anoActual - 2005;

        const values: number[] = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
        const symbols: string[] = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"];

        let result: string = '';

        // Itera a través de los valores y símbolos
        for (let i = 0; i < values.length; i++) {
            while (num >= values[i]) {
                num -= values[i];
                result += symbols[i];
            }
        }
        this._numeroEdicionTexto = result;
        return result;
    }

    get numeroEdicionTexto(): string {
        return this._numeroEdicionTexto;
    }

}